import { Hash, type LucideIcon } from 'lucide-react';

export const NumberIcon: LucideIcon = Hash;
